import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

import { I18nProvider } from "./I18nProvider";
import AutoMAH from "./sites/AutoMAH";
import Privacy from "./sites/Privacy";
import Imprint from "./sites/Imprint";
import Tos from "./sites/Tos";
import SchweizVerkaufen from "./sites/SchweizVerkaufen";
import Topbar from "./sites/Topbar";
import Footer from "./sites/Footer";
import HandyLeiste from "./sites/HandyLeiste";
import NichtGefunden from "./sites/NichtGefunden";
import { ScrollBalken, NachOben } from "./sites/Effekte";

function App() {
  return (
    <Router>
      <I18nProvider>
        <ScrollToTop />
        <ScrollBalken />
        <Topbar />

        <Routes>
          <Route path="/" element={<AutoMAH />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/tos" element={<Tos />} />
          {/* Regionsseite fuer Suchende aus der Schweiz. Eigene Adresse,
              eigener Titel, damit Google sie als eigenes Thema erkennt. */}
          <Route path="/auto-verkaufen-schweiz" element={<SchweizVerkaufen />} />
          {/* Faengt ALLE unbekannten Adressen ab. Ohne diese Zeile zeigte
              jeder Tippfehler eine leere Seite mit Kopf und Fuss. */}
          <Route path="*" element={<NichtGefunden />} />
        </Routes>

        <Footer />
        <HandyLeiste />
        <NachOben />
      </I18nProvider>
    </Router>
  );
}

export default App;
